function getRuntimeConfig() {
    if (typeof window !== "undefined" && window.__PTB_CONFIG__) {
        return window.__PTB_CONFIG__;
    }
    /* Legacy: classic public/config.js that declared global const DOMAIN / APP_NAME / … */
    if (typeof DOMAIN !== "undefined") {
        return {
            APP_NAME: typeof APP_NAME !== "undefined" ? APP_NAME : "PHOTOBOMB",
            DOMAIN,
            USE_2FA: typeof USE_2FA !== "undefined" ? USE_2FA : false,
            VERSION: typeof VERSION !== "undefined" ? VERSION : "1.0.0",
        };
    }
    return {
        APP_NAME: "PHOTOBOMB",
        DOMAIN: "http://localhost",
        USE_2FA: false,
        VERSION: "1.0.0",
    };
}

const runtime = getRuntimeConfig();
const env = {};
const PROD = true;
const URL = PROD ? runtime.DOMAIN : "http://localhost";
const PORT = 1337;
env.url = URL;
env.port = PORT;
env.parseServerUrl = `${URL}:${PORT}/parse`;
env.apiUrl = `${URL}:${PORT}/api/v1`;
env.appId = "97dd70d3-da0a-432a-9dc9-01ef5a06c6a9";
env.masterKey = "597e1c2d-21f6-40d4-8748-29a5f2f30f98";
env.javascriptKey = "bdbd0236-bc83-457d-a5b0-08a273859dbb";
env.appName = `${runtime.APP_NAME} ADMIN`;
env.version = runtime.VERSION;
env.use2FA = !!runtime.USE_2FA;
export default env;
